var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.getAppleVppIcon)?_c('img',{attrs:{"src":_vm.getAppleVppIcon}}):_vm._e(),(!_vm.getAppleVppIcon)?_c('Icon',{attrs:{"icon":"applications","scale":3}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }